import React, { useState, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../firebase.js";
import { doc, getDoc } from "firebase/firestore";
import { AuthorProfile } from "../functions/Profile/AuthorProfile.js";
import { ReaderProfile } from "../functions/Profile/ReaderProfile.js";
import DOMPurify from "dompurify";
import MiniUserCard from "../components/user/MiniUserCard.js";
import { FollowButton } from "../components/user/FollowButton.js";
import DisplayBookListsFromProfilePage from "../components/BookStacks/DisplayBookLists.js";
import NewBookList from "../components/BookStacks/NewBookList.js";
import { DisplayPublishedBooks } from "../components/PublishedBooks/DisplayPublishedBooks.js";
import AddPublishedBooksModal from "../components/PublishedBooks/AddPublishedBooksModal.js";
import Activity from "./Activity.js";
import UserFeed from "../components/UserFeed.js";
import { FaEllipsisV } from "react-icons/fa";
import ReactDOM from "react-dom";
import {
  updateDoc,
  arrayUnion,
  arrayRemove,
  collection,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import createNotification from "../functions/createNotification.js";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import fetchUsernameWithUID from "../functions/fetchUsernameWithUID.js";
import Post from "./Post/Post.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { updateGenres } from "./Post/functions/update.jsx";
const OptionsModal = ({ isMuted, toggleMute, reportUser, onClose }) => {
  return ReactDOM.createPortal(
    <div className="flex items-center justify-center fixed mt-10 top-0 left-0 right-0 bottom-0 z-10">
      <div className="overlay-inner top-4 right-0 bg-white shadow-lg p-4 rounded">
        <ul>
          <li className="cursor-pointer mb-2" onClick={toggleMute}>
            {isMuted ? "Unmute" : "Mute"}
            {/* tooltip to desc what muting a user does muted users cannot send you notifications */}
            <span className="ml-2 text-gray-500 text-sm">
              Muted users cannot send you notifications
            </span>
          </li>
          <li className="cursor-pointer mb-2" onClick={reportUser}>
            Report
          </li>
        </ul>
        <button
          className="mt-4 w-full bg-gray-200 p-2 rounded"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>,
    document.getElementById("portal")
  );
};

const ViewSavedPosts = ({ close, data }) => {
  return (
    <>
      <div className="overlay relative z-10">
        <div className="overlay-inner">
          <div className="flex justify-center items-center">
            <button
              className="bg-maroon hover:bg-lightmaroon p-3 rounded-lg text-white"
              onClick={close}
            >
              {" "}
              Close
            </button>
          </div>
          <div>
            <div className="test">
              <div className="flex justify-center items-center text-xl font-bold">
                Saved Posts
              </div>
              {data && data.savedPosts ? (
                data.savedPosts.map((post, index) => (
                  <>
                    <Post key={index} postId={post} />
                  </>
                ))
              ) : (
                <p>You have no saved posts</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const BaseProfile = ({ UserID }) => {
  const currentUser = auth.currentUser;
  const [a, setA] = useState();
  const [user, loading] = useAuthState(auth);
  //   const uid = user ? user.uid : null;
  const defaultProfilePicture = require("../assets/default-profile-picture.jpg");
  const defaultBackgroundPicture = require("../assets/reader-profile-banner.jpg");
  const [userData, setUserData] = useState(null);
  const [bio, setBio] = useState(null);
  const [genres, setGenres] = useState(null);
  const [pronouns, setPronouns] = useState(null);
  const [username, setUsername] = useState(null);
  const [role, setRole] = useState(null);
  const [extraRoles, setExtraRoles] = useState(null);
  const [profilePicture, setProfilePicture] = useState(null);
  const [backgroundPicture, setBackgroundPicture] = useState(null);
  const [followersCount, setFollowersCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);
  const [showFollowers, setShowFollowers] = useState(false);
  const [followersFetched, setFollowersFetched] = useState(false);
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [showFollowing, setShowFollowing] = useState(false);
  const [followingFetched, setFollowingFetched] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  const [show, setShow] = useState(false);
  const [currentUserCheck, setCurrentUserCheck] = useState(null);
  const [bookLists, setBookLists] = useState(null);
  const [bookListsCount, setBookListsCount] = useState(0);
  const [publishedBooks, setPublishedBooks] = useState(null);
  const [publishedBooksCount, setPublishedBooksCount] = useState(0);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [showSavedPosts, setShowSavedPosts] = useState(false);

  const noShowSavedPosts = () => {
    setShowSavedPosts(false);
  };
  const noShow = () => setShow(false);
useEffect(()=>{
  const test = async()=>{
    await updateGenres(userData)
  }
  test()
},[userData])
  // console.log("Base profile: ",user.uid);
  useEffect(() => {
    const fetchReaderData = async () => {
      const myProfile = new ReaderProfile(UserID);
      await myProfile.initialize();
      // specifically for readers.
      await myProfile.setBookLists();
      setProfilePicture(myProfile.getProfilePicture());
      setBackgroundPicture(myProfile.getBackgroundPicture());
      myProfile.getUID();
      await myProfile.setUserData();
      setUserData(myProfile.getUserData());
      //await updateGenres(userData)
      //readers
      setExtraRoles(await myProfile.getExtraRoles());
      setBookLists(myProfile.getBookLists());
      setBookListsCount(myProfile.getBookListLength());
      setIsFollowing(myProfile.getIsFollowing());
      setBio(myProfile.getBio());
      setGenres(myProfile.getGenres());
      setPronouns(myProfile.getPronouns());
      setUsername(myProfile.getUsername());
      setFollowersCount(myProfile.getFollowersCount());
      setFollowingCount(myProfile.getFollowingCount());
      setFollowers(myProfile.getFollowers());
      setFollowing(myProfile.getFollowing());
      console.log("What is isFollowing: ", isFollowing);
      if (UserID === user.uid) {
        setCurrentUserCheck(true);
      } else {
        setCurrentUserCheck(false);
      }
      // console.log("Extra Roles: ",extraRoles);
    };
    const fetchAuthorData = async () => {
      console.log("Author Data");
      const myProfile = new AuthorProfile(UserID);
      console.log("initializing....");
      await myProfile.initialize();
      setProfilePicture(myProfile.getProfilePicture());
      setBackgroundPicture(myProfile.getBackgroundPicture());
      myProfile.getUID();
      await myProfile.setUserData();
      setUserData(myProfile.getUserData());
     //await updateGenres(userData)
      await myProfile.setPublishedBooks();
      setIsFollowing(myProfile.getIsFollowing());
      setBio(myProfile.getBio());
      setGenres(myProfile.getGenres());
      setPronouns(myProfile.getPronouns());
      setUsername(myProfile.getUsername());
      setFollowersCount(myProfile.getFollowersCount());
      setFollowingCount(myProfile.getFollowingCount());
      setFollowers(myProfile.getFollowers());
      setFollowing(myProfile.getFollowing());
      setPublishedBooks(myProfile.getPublishedBooks());
      setPublishedBooksCount(myProfile.getPublishedBooksLength());
      console.log("What is isFollowing: ", isFollowing);
      if (UserID === user.uid) {
        setCurrentUserCheck(true);
      } else {
        setCurrentUserCheck(false);
      }
      console.log("Author data set successfully.");
    };
    const fetchRole = async () => {
      try {
        const userRef = doc(db, "users", UserID);
        const docSnapshot = await getDoc(userRef);
        if (docSnapshot.exists()) {
          if (docSnapshot.data().role && docSnapshot.data().role[0]) {
            setRole(docSnapshot.data().role[0]);
          }
          console.log("Roles: ", docSnapshot.data().role[0]);
          console.log("Role fetched successfully");
        } else {
          console.log("User Role does not exist");
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
      }
    };
    fetchRole();
    if (role && role == "Reader") fetchReaderData();
    else if (role && role == "Author") fetchAuthorData();

    console.log("Profile set successfully");
  }, [user, role, profilePicture]);
  if (loading) {
    return <div>Loading...</div>;
  }

  const toggleMute = async () => {
    try {
      if (!userData || !userData.UID) {
        console.error("User data or UID not initialized.");
        return;
      }

      const currentUser = auth.currentUser;
      if (!currentUser) {
        console.error("Current user not authenticated.");
        return;
      }

      const currentUserId = currentUser.uid;
      const userRef = doc(db, "users", currentUserId);
      const userDoc = await getDoc(userRef);

      if (!userDoc.exists()) {
        console.error("User document not found.");
        return;
      }

      const userDocData = userDoc.data();
      const mutedList = userDocData.muted || [];

      if (mutedList.includes(userData.UID)) {
        // Unmute the user
        await updateDoc(userRef, {
          muted: arrayRemove(userData.UID),
        });
        setIsMuted(false);
        toast.success("User unmuted successfully.");
        // if they sent a follow request, notify the user of the follow request
        await createNotification(
          userData.UID,
          currentUserId,
          new Date(),
          "follow_request"
        );
      } else {
        // Mute the user
        await updateDoc(userRef, {
          muted: arrayUnion(userData.UID),
        });
        setIsMuted(true);
        toast.success("User muted successfully.");

        //delete all notifications from the user you've muted
        const notificationsRef = collection(
          db,
          "users",
          currentUserId,
          "notifications"
        );
        const notificationsSnapshot = await getDocs(notificationsRef);
        notificationsSnapshot.forEach(async (doc) => {
          if (doc.data().fromUserId === userData.UID) {
            await deleteDoc(doc.ref);
          }
        });
      }
    } catch (error) {
      console.error("Error muting/unmuting user:", error);
      toast.error("Error muting/unmuting user.");
    }
  };

  const reportUser = () => {
    // Your reportUser logic
    toast.info("Reported user.");
  };

  const toggleFollowers = async () => {
    try {
      console.log("userData: ", userData);
      console.log("uid: ", UserID);

      if (!showFollowers && !followersFetched) {
        if (!UserID) {
          console.error("UID not initialized.");
          return;
        }

        console.log("User UID:", UserID);

        // Access the 'followers' array within the user document data
        const followersData = followers || [];
        console.log("Followers Data:", followersData);
        setFollowers(followersData);
        setFollowersFetched(true);
      }
      setShowFollowers((prevState) => !prevState);
    } catch (error) {
      console.error("Error fetching followers:", error);
    }
  };

  const toggleFollowing = async () => {
    try {
      if (!showFollowing && !followingFetched) {
        if (!UserID) {
          console.error("UID not initialized.");
          return;
        }

        console.log("User UID:", UserID);

        // Access the 'following' array within the user document data
        const followingData = following || [];
        console.log("Following Data:", followingData);
        setFollowing(followingData);
        setFollowingFetched(true);
      }
      setShowFollowing((prevState) => !prevState);
    } catch (error) {
      console.error("Error fetching following:", error);
    }
  };

  const getid = async () => {
    const as = await fetchUsernameWithUID(UserID);
    console.log(as);
    setA(as);
  };
  getid();
  return (
    <>
      <div className="ml-[5.2rem]">
        <div className="flex flex-col bg-lightcolor h-full">
          <div className="flex justify-center items-center w-full">
            {backgroundPicture ? (
              <img
                src={backgroundPicture}
                alt="Background Picture"
                className="w-full h-96 object-cover"
              />
            ) : (
              <img
                src={defaultBackgroundPicture}
                alt="Background Picture"
                className="w-full h-96 object-cover"
              />
            )}
          </div>
          <div className="flex flex-row">
            <div className="flex justify-center items-center w-full">
              {profilePicture ? (
                <img
                  src={profilePicture}
                  alt="Profile Picture"
                  className="h-40 w-40 rounded-full border-4 border-white -mt-20 ml-3"
                />
              ) : (
                <img
                  src={defaultProfilePicture}
                  alt="Profile Picture"
                  className="h-40 w-40 rounded-full border-4 border-white -mt-20"
                />
              )}
            </div>
            {currentUserCheck ? (
              <>
                <button
                  className="relative top-4 right-4"
                  onClick={() => setShowSavedPosts(true)}
                >
                  <FontAwesomeIcon icon={faFloppyDisk} />
                </button>
                {showSavedPosts && (
                  <ViewSavedPosts close={noShowSavedPosts} data={userData} />
                )}
              </>
            ) : (
              <div>
                <div>
                  <button
                    className="relative top-4 right-4"
                    onClick={() => setShowOptionsModal(true)}
                  >
                    <FaEllipsisV />
                  </button>
                </div>
                <div id="portal">
                  {showOptionsModal && (
                    <OptionsModal
                      isMuted={isMuted}
                      toggleMute={toggleMute}
                      reportUser={reportUser}
                      data={userData}
                      onClose={() => setShowOptionsModal(false)}
                    />
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col justify-center items-center w-full space-y-4">
            <div className="text-3xl font-bold">{username}</div>
            <div>@{username}</div>

            <div className="px-3 py-2 h-10 rounded-lg shadow-lg bg-maroon text-white">
              {role && (
                <div className="mb-2">
                  <ul className="list-disc ml-4">{role}</ul>
                </div>
              )}
            </div>

            {extraRoles > 0 && (
                <div>
                  <ul>
                    {extraRoles.map((role, index) => (
                      <li key={index}>{role}</li>
                    ))}
                  </ul>
                </div>
            )}

            <div className="text-lg flex flex-row gap-5 mx-48">
              <div className="text-center">
                {genres ? genres.join(", ") : "No genres selected"}
              </div>
            </div>

            <div className="flex flex-row ml-24 text-xl ">
              <div className="w-[220px]">
                <button onClick={toggleFollowers}>
                  {followersCount} Followers
                </button>
                {showFollowers && (
                  <div className="mt-2 max-h-48 w-[220px] overflow-y-auto">
                    <ul className="list-none">
                      {followers.map((followerId, index) => (
                        <li key={index} className="mb-2">
                          <MiniUserCard userId={followerId} />
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <div className="w-[220px]">
                <button onClick={toggleFollowing}>
                  {followingCount} Following
                </button>
                {showFollowing && (
                  <div className="mt-2 max-h-48 w-[220px] overflow-y-auto">
                    <ul className="list-none">
                      {following.map((followingId, index) => (
                        <li key={index} className="mb-2">
                          <MiniUserCard userId={followingId} />
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            <div className="text-lg flex flex-row gap-5">
              {bio ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: `<strong>Bio:</strong> ${DOMPurify.sanitize(bio)}`,
                  }}
                ></p>
              ) : (
                <p className="mb-2 flex flex-col">
                  <span className="text-orange-500">No bio provided</span>
                </p>
              )}
            </div>

            {/* <div> Is Following: {String(isFollowing)}</div> */}
            {user && user.uid !== UserID && (
              <FollowButton targetUserId={UserID} isFollowing={isFollowing} />
            )}
            <div className="flex flex-row gap-5">
              <span className="mr-1">
                {" "}
                <Link to={`/stats/${UserID}`}>Stats📊</Link>
              </span>
              {role === "Author" && (
                <span>
                  <Link to={`/ReaderQandA/${a}`}>Author Q&A ❓</Link>
                </span>
              )}
            </div>

            <div className="w-full border-b border-gray-700 mt-4"></div>
            <div className="flex justify-between items-center w-full">
              <div className="flex flex-col justify-center items-center w-full border-r border-gray-700 pr-4">
                {role === "Author" ? (
                  //When the user is Author
                  <div>
                    <button className="text-2xl text-black">
                      Books Published
                    </button>
                  </div>
                ) : (
                  //When the user is reader

                  <div>
                    <button className="text-2xl text-black">Book Lists</button>
                  </div>
                )}
              </div>
              <div className="flex flex-col items-center w-full">
                <button className="text-2xl text-black">Posts</button>
              </div>
            </div>
            <div className="w-full border-b border-gray-700 mt-4"></div>

            <div className="flex flex-row w-full">
              {role === "Author" ? (
                //When the user is Author
                <>
                  <div className="flex flex-col w-1/2 border-r border-gray-700 px-2 ml-2">
                    <div className="flex justify-center">
                      <button
                        onClick={() => setShow(true)}
                        className="bg-maroon rounded-lg p-3 text-white hover:bg-lightmaroon"
                      >
                        Add your published books
                      </button>
                    </div>
                    <DisplayPublishedBooks
                      booksPublished={publishedBooks}
                      booksPublishedCount={publishedBooksCount}
                    />
                  </div>
                  {show && (
                    <AddPublishedBooksModal
                      show={show}
                      onClose={noShow}
                      user={user}
                    />
                  )}
                </>
              ) : (
                //When the user is reader

                <div className="flex flex-col w-1/2 border-r border-gray-700 px-2 ml-2">
                  <div>
                    <div className="flex items-center justify-center">
                      {currentUserCheck ? (
                        <>
                          <button
                            onClick={() => setShow(true)}
                            className="bg-maroon hover:bg-lightmaroon rounded-full p-3 mt-2 text-white"
                          >
                            + Create a new Book List
                          </button>
                          {show && (
                            <NewBookList
                              show={show}
                              onClose={noShow}
                              user={user}
                            />
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div>
                      <DisplayBookListsFromProfilePage
                        user={user}
                        bookStacks={bookLists}
                        bookStacksCount={bookListsCount}
                        loggedInUser={currentUserCheck}
                      ></DisplayBookListsFromProfilePage>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex flex-col w-1/2 md:flex-row p-4">
                <div className="w-full">
                  <UserFeed userid={UserID} />

                  <div className="flex flex-col justify-center items-center w-1/2">
                    <div className="space-x-32"></div>
                  </div>
                </div>
              </div>

              {/* <div>
                <div className="test">
                  <h1 className="text-xl font-bold">Saved Posts</h1>
                  {userData && userData.savedPosts ? (
                    userData.savedPosts.map((post, index) => (
                      <>
                        <Post key={index} postId={post} />
                      </>
                    ))
                  ) : (
                    <p>You have no saved posts</p>
                  )}
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BaseProfile;
